import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { IScene } from '../../../../types/Scenes/scenesTypes';
import { SideBarDeleteActionWithPopup } from '../../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import {
  StyledContainerItems,
  StyledContainerFooterSideBar
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../../i18n';
import { useDeleteMultipleScenesMutation } from '../../../../services/scenes/sceneService';

interface ISceneDetailsProps {
  selectedScenes: IScene[];
  setSelectedScenes: (scenes: IScene[]) => void;
  setOpenSideBar: (openSideBar: boolean) => void;
  reloadTable: () => void;
}
export const MultipleSceneDetails = ({
  selectedScenes,
  setSelectedScenes,
  setOpenSideBar,
  reloadTable
}: ISceneDetailsProps) => {
  const [deleteSc, { isSuccess: isSuccessDelete }] =
    useDeleteMultipleScenesMutation();
  const deleteScene = () => {
    deleteSc(selectedScenes.map((scene) => scene.id));
  };

  useEffect(() => {
    if (isSuccessDelete) {
      setOpenSideBar(false);
      setSelectedScenes([]);
      toast.success(Strings.scenes.successDeleteScene);
      reloadTable();
    }
  }, [isSuccessDelete]);
  return (
    <>
      {selectedScenes && (
        <>
          <StyledContainerItems>
            <SideBarDeleteActionWithPopup
              onDelete={() => deleteScene()}
              titleConfirmation={Strings.scenes.deleteSceneTitle}
              textConfirmation={Strings.common.thisActionIsIrreversible}
              textIcon={Strings.scenes.deleteScenes}
            />
          </StyledContainerItems>

          <StyledContainerFooterSideBar>
            <button
              type="button"
              className="btn-cancel"
              onClick={() => {
                setOpenSideBar(false);
                setSelectedScenes([]);
              }}
            >
              {Strings.common.cancel}
            </button>
          </StyledContainerFooterSideBar>
        </>
      )}
      <div />
    </>
  );
};
